import { createStore } from 'vuex'

export default createStore({
  state: {
    title:"二维码追溯管理平台",
    // 权限
    control:false,
    // 高德配置
    gd:{
      key:'',
      secret:'',
      map:'',
    },
    // 防伪模块权限
    fw_control:false,
    // 溯源模块权限
    sy_control:false,
    // 物流模块权限
    wl_control:false,
    // 分发模块权限
    ff_control:false,
    // 用户名
    UserName:'',
    //侧边栏开关
    switch:true,
    // 左侧主题
    theme:"dark", //dark light
    // 顶部主题
    TopTheme:"dark", //dark light
    // 侧边栏背景色
    LeftBackgroundColor:"#040C18",//#040C18
    // 顶部背景色
    TopBackgroundColor:"#040C18"
  },
  getters: {
  },
  mutations: {
    ChangControl(state,data){
      state.control = data
    },
    FwControl(state,data){
      state.fw_control = data
    },
    SyControl(state,data){
      state.sy_control = data
    },
    WlControl(state,data){
      state.wl_control = data
    },
    FFControl(state,data){
      state.ff_control = data
    },
    ChangGd(state,data){
      state.gd = data
    },
    Uname(state,data){
      state.UserName = data
    },
    Uswitch(state,data){
      state.switch = data
    },
    Utheme(state,data){
      state.theme = data
    }
  },
  actions: {
  },
  modules: {
  }
})
